import React from "react";
import ReactTooltip from "react-tooltip";

import "./style.scss";
import infoImg from "images/icons/info-icon.svg";
import styles from "./style.module.scss";

const InfoIcon = ({ tooltip }) => {
  return (
    <span className={styles.container} data-tip={tooltip}>
      <img src={infoImg} width={16} height={16} alt={""} />
      <ReactTooltip
        className={styles.tooltip}
        html={true}
        arrowColor="#69bcc6"
      />
    </span>
  );
};

export default InfoIcon;
